import {Typography, css, useTheme} from '@mui/material';
import {DlMuiChip, DlMuiDynamicIcon, DlMuiPopper, GetStylesFunction, TranslateUtils, useMuiAnchor} from '@wallaby-ui/core';
import * as React from 'react';
import {useIntl} from 'react-intl';
import {useStore} from 'react-redux';
import {useParams} from 'react-router-dom';
import {WallabyCoreSchema} from 'src/js/common/types';
import {EntityLink} from 'src/js/containers/file/components/EntityLink';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';
import {getHospitalizationDocumentLink} from 'src/js/containers/hospitalizations/hospitalizations_helpers';
import {baseDocumentsListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_documents_list_link_formatter_params';

type Props = TemplatedCellRendererParams<WallabyCoreSchema.components['schemas']['DocumentForEncounterDto']>;

export const DocumentNameFormatterV2: React.FC<Props> = (props) => {
  const {value, data} = props;

  const hasTooltip = !!value;
  const theme = useTheme();
  const intl = useIntl();
  const styles = getStyles({theme});
  const store = useStore();
  const routeParams = useParams();

  const {documentId, hospitalizationId} = baseDocumentsListLinkFormatterParams(props, {
    routeParams,
    store,
  });
  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);
  const route = hospitalizationId && documentId ? getHospitalizationDocumentLink(hospitalizationId, documentId, '/v2') : '';

  return (
    <div css={styles.wrapper}>
      <Typography onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave} css={styles.typography} variant={'textButton'}>
        <EntityLink route={route} suppressPadding overflowStyles style={{height: 22}}>
          {value}
        </EntityLink>
        {!data.isRelatedToEncounter ? (
          <DlMuiDynamicIcon iconName='merieSpikedExclamationIcon' useFixedViewBox={14} style={{padding: 0}} />
        ) : null}
      </Typography>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <div css={styles.popperWrapper}>
          <Typography variant={'popper'}>{value}</Typography>
          {!data.isRelatedToEncounter && (
            <Typography variant={'popper'}>{TranslateUtils.translate('documents.list.notIsRelatedToEncounter.tooltip', intl)}</Typography>
          )}
        </div>
      </DlMuiPopper>
    </div>
  );
};
DocumentNameFormatterV2.displayName = 'DocumentNameFormatterV2';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    width: 100%;
  `,
  typography: css`
    width: 100%;
    padding: ${options?.theme?.spacing(1, 0)};
    display: flex;
    align-items: flex-start;
    text-decoration: underline;
    & > *:first-of-type {
      flex: 1;
    }
    & * {
      text-align: left !important;
    }
  `,
  chip: css`
    margin: 3px 0 0 4px;
  `,
  popperWrapper: css`
    display: flex;
    flex-direction: column;
  `,
});
